module.exports = __webpack_public_path__ + "img/sushiswap_logo.9925a33d.svg";